var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import * as ServiceUtilisateur from '../../services/utilisateur';
import { useState } from 'react';
import { Table } from '../../utils/Table';
import { CollaborateurIcon, DeleteIcon, EditIcon, VisionIcon, } from '../../utils/Icons';
import { TYPES } from '../../utils/FormikTextField';
import { FormikGenerator } from '../../utils/FormikGenerator';
import { Modal } from '../../utils/Modal';
import { IconButton } from '../../utils/IconButton';
import { ConfirmDialog } from '../../utils/ConfirmDialog';
import { Chip } from '@mui/material';
import { Link } from '../../utils/Link';
import * as ServiceUtils from '../../services/utils';
import { UtilisateurSchema } from '../../utils/ValidationSchema';
import { UtilisateurVisions } from './UtilisateurVisions';
import { getOriginalUser } from '../../services/utilisateur';
export var Utilisateur = function () {
    var _a = useState([]), utilisateurs = _a[0], setUtilisateurs = _a[1];
    var _b = useState([]), habilitations = _b[0], setHabilitations = _b[1];
    var _c = useState([]), collaborateurs = _c[0], setCollaborateurs = _c[1];
    var _d = useState(null), utilisateurIdVision = _d[0], setUtilisateurIdVision = _d[1];
    var originalUser = getOriginalUser();
    var getData = function () { return __awaiter(void 0, void 0, void 0, function () {
        var datas;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, Promise.all([
                        ServiceUtilisateur.getUtilisateurListe(),
                        ServiceUtils.getListe('Habilitation', null),
                        ServiceUtils.getSelectOptions('collaborateurs'),
                    ])];
                case 1:
                    datas = _a.sent();
                    setUtilisateurs(datas[0]);
                    setHabilitations(datas[1]);
                    setCollaborateurs(datas[2]);
                    return [2 /*return*/];
            }
        });
    }); };
    var handleDelete = function (_a, refresh) {
        var IdUtilisateur = _a.IdUtilisateur;
        return __awaiter(void 0, void 0, void 0, function () {
            var confirmation;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, ConfirmDialog({
                            title: 'Suppression',
                            content: 'Êtes-vous sûr de vouloir supprimer cet utilisateur ?',
                            color: 'error',
                        })];
                    case 1:
                        confirmation = _b.sent();
                        if (!confirmation.isOk) return [3 /*break*/, 3];
                        return [4 /*yield*/, ServiceUtilisateur.deleteUtilisateur(IdUtilisateur)];
                    case 2:
                        _b.sent();
                        refresh();
                        _b.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    var handleClickUsurpation = function (UtilisateurId) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, ServiceUtilisateur.usurpation(UtilisateurId)];
                case 1:
                    _a.sent();
                    window.location.href = '/';
                    return [2 /*return*/];
            }
        });
    }); };
    var handleClickVisions = function (UtilisateurId) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            setUtilisateurIdVision(UtilisateurId);
            return [2 /*return*/];
        });
    }); };
    return (_jsxs(_Fragment, { children: [_jsx(Table, { canEdit: true, canAdd: false, isResponsive: true, headers: [
                    {
                        label: 'Utilisateur',
                        component: function (value) { return value.getLibelle; },
                    },
                    {
                        label: 'Login',
                        assessor: 'Login',
                    },
                    {
                        label: 'Actif',
                        minWidth: true,
                        component: function (value) { return (_jsx(Chip, { color: value.Actif ? 'success' : 'default', label: value.Actif ? 'Oui' : 'Non' })); },
                    },
                    {
                        label: 'Administrateur',
                        minWidth: true,
                        component: function (value) { return (_jsx(Chip, { color: value.Administrateur ? 'success' : 'default', label: value.Administrateur ? 'Oui' : 'Non' })); },
                    },
                    {
                        label: 'Collaborateur',
                        component: function (value) {
                            return value.collaborateur &&
                                value.collaborateur.IdCollaborateur && (_jsx(Link, { title: value.collaborateur.getLibelle, color: "collaborateur", to: '/collaborateur/fiche/' +
                                    value.collaborateur.IdCollaborateur, className: "flex", icon: _jsx(CollaborateurIcon, {}) }));
                        },
                    },
                    {
                        label: 'Habilitation',
                        component: function (value) {
                            return value.habilitation ? value.habilitation.Libelle : '-';
                        },
                    },
                    {
                        label: 'Email',
                        assessor: 'Email',
                    },
                    {
                        align: 'right',
                        component: function (value, _a) {
                            var handleUpdate = _a.handleUpdate, refresh = _a.refresh;
                            return (_jsxs(_Fragment, { children: [originalUser.Licence.UseVision ? (_jsx(IconButton, __assign({ color: "primary", tooltip: "Visions", onClick: function () { return handleClickVisions(value.IdUtilisateur); } }, { children: _jsx(VisionIcon, {}) }))) : (_jsx(_Fragment, {})), _jsx(IconButton, __assign({ color: "primary", tooltip: "Modifier", onClick: function () { return handleUpdate(value); } }, { children: _jsx(EditIcon, {}) })), _jsx(IconButton, __assign({ color: "error", tooltip: "Supprimer", onClick: function () { return handleDelete(value, refresh); } }, { children: _jsx(DeleteIcon, {}) }))] }));
                        },
                    },
                ], datas: utilisateurs ? utilisateurs : [], renderModalEdition: function (handleClose, utilisateurSelected) {
                    return (_jsx(Modal, __assign({ handleCloseModal: handleClose, forceOpen: true, title: "Utilisateur" }, { children: _jsx(FormikGenerator, { submitLabel: utilisateurSelected.IdUtilisateur ? 'Enregistrer' : 'Ajouter', validationSchema: UtilisateurSchema, datas: utilisateurSelected, onSubmit: function (newUtilisateur) { return __awaiter(void 0, void 0, void 0, function () {
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0: return [4 /*yield*/, ServiceUtilisateur.postUtilisateur(__assign(__assign({}, utilisateurSelected), newUtilisateur))];
                                        case 1:
                                            _a.sent();
                                            handleClose();
                                            return [2 /*return*/];
                                    }
                                });
                            }); }, additionalInitialValues: ['visions'], fields: [
                                __spreadArray([
                                    {
                                        xs: 4,
                                        name: 'Actif',
                                        label: 'Actif',
                                        type: TYPES.BOOLEAN,
                                    },
                                    {
                                        xs: 4,
                                        name: 'Administrateur',
                                        label: 'Administrateur',
                                        type: TYPES.BOOLEAN,
                                    },
                                    {
                                        xs: 4,
                                        name: 'CalendrierId',
                                        label: 'Identifiant calendrier',
                                        type: TYPES.TEXT,
                                    },
                                    {
                                        xs: 4,
                                        name: 'Login',
                                        label: 'Login',
                                        type: TYPES.TEXT,
                                    },
                                    {
                                        xs: 4,
                                        name: 'Nom',
                                        label: 'Nom',
                                        type: TYPES.TEXT,
                                        uppercaseFirstChar: true,
                                    },
                                    {
                                        xs: 4,
                                        name: 'Prenom',
                                        label: 'Prénom',
                                        type: TYPES.TEXT,
                                        uppercaseFirstChar: true,
                                    },
                                    {
                                        xs: 4,
                                        name: 'Email',
                                        label: 'Email',
                                        type: TYPES.TEXT,
                                    },
                                    {
                                        xs: 4,
                                        name: 'CollaborateurId',
                                        label: 'Collaborateur par défaut',
                                        type: TYPES.SELECT,
                                        options: collaborateurs ? collaborateurs : [],
                                    }
                                ], (originalUser.Licence.UseVision
                                    ? [
                                        {
                                            xs: 4,
                                            name: 'HabilitationId',
                                            label: 'Habilitation',
                                            type: TYPES.SELECT,
                                            options: habilitations ? habilitations : [],
                                        },
                                    ]
                                    : []), true),
                            ] }) })));
                }, refresh: getData }), utilisateurIdVision && (_jsx(UtilisateurVisions, { UtilisateurId: utilisateurIdVision, handleClose: function () {
                    setUtilisateurIdVision(null);
                } }))] }));
};
//# sourceMappingURL=Utilisateur.js.map